<template>
  <div>
    <div class="is-position-relative height-151">
      <img :src="logo ? logo : '/static/img/default-placeholder.png'"
           class="image logo-img" alt="Logo"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'logoAgence',
  props: {
    logo: {
      type: String,
      required: true,
      default: null,
    },
  },
};
</script>

<style scoped>

</style>
